import { ErrorHandler, Injectable } from '@angular/core';

const RELOAD_FLAG_KEY = 'bumaapp_chunk_reload';

const CHUNK_ERROR_PATTERN =
  /Failed to fetch dynamically imported module|ChunkLoadError|Loading chunk [\w-]+ failed|error loading dynamically imported module/i;

/**
 * Después de cada despliegue, Angular renombra todos los chunk-*.js con un hash nuevo.
 * Una pestaña que quedó abierta desde antes del despliegue sigue referenciando los
 * nombres viejos: al navegar a una ruta lazy, el fetch del chunk da 404 y Angular
 * lanza este error sin ninguna recuperación automática.
 *
 * En vez de dejar la app rota en pantalla, se recarga la página una sola vez por
 * sesión (sessionStorage evita un loop si el problema no fuera en realidad un
 * chunk desactualizado). El flag se limpia al arrancar la app con éxito, así que
 * cada sesión nueva vuelve a tener su "intento" disponible.
 */
@Injectable()
export class ChunkErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    const message = this.extractMessage(error);

    if (CHUNK_ERROR_PATTERN.test(message)) {
      if (!sessionStorage.getItem(RELOAD_FLAG_KEY)) {
        sessionStorage.setItem(RELOAD_FLAG_KEY, '1');
        window.location.reload();
        return;
      }
    }

    console.error(error);
  }

  private extractMessage(error: unknown): string {
    if (error instanceof Error) return error.message;
    if (typeof error === 'string') return error;
    return String(error);
  }
}

export function clearChunkReloadFlag(): void {
  sessionStorage.removeItem(RELOAD_FLAG_KEY);
}
